import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {ReactComponent as ArrowLeft} from '../../img/left-arrow.svg';
import {ReactComponent as ArrowRight} from '../../img/right-arrow.svg';
import {useStyles} from './helpers';
import Dialog from '@material-ui/core/Dialog';

const TableCasinoKyc = ({allPage, perPage, columns, rows, changePage, changeRowsPerPage, width, pagination, accept, cancel, order}) => {
    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(perPage);
    const [openModal, setOpenModal] = React.useState(false);
    const [photo, setPhoto] = React.useState('');
    
    return (
        <div style={{width: '100%', maxWidth: width}}>
            <TableContainer className={classes.container} >
            <Table stickyHeader aria-label="sticky table" >
                <TableHead >
                <TableRow style={{height: 25}}>
                    {columns.map((column, key) => (
                    <TableCell
                        key={column.id}
                        align={column.align}
                        onClick={() => {
                            if (order) {
                                order(column);
                            }
                        }}
                        style={{minWidth: column.minWidth, borderBottom: '1px solid #3a4b7e', backgroundColor: 'inherit', color: '#ffce01', fontFamily: 'PT Sans, sans-serif', fontSize: 12, fontWeight: 700, padding: 0, paddingLeft: key === 0 ? 10 : 0, margin: 0 }}
                    >
                        {column.label}
                    </TableCell>
                    ))}
                </TableRow>
                </TableHead>
                <TableBody style={{width: '100%'}}>
                {rows.map((row, key) => {
                    return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code} style={{background: key % 2 === 0 ? '#141b33' : '#1b2039'}}>
                        {columns.map((column, key) => {
                        const value = row[column.id];
    
                        return (
                            <TableCell key={column.id} align={column.align} style={{border: 'none', color: '#f3f3f4', padding: 0, margin: 0, height: 30, paddingLeft: key === 0 ? 10 : 0}}>
                                {
                                    column.id === 'photo' &&
                                    <img 
                                        alt="icon"
                                        src={value}
                                        onClick={() => {
                                            setPhoto(value); 
                                            setOpenModal(true)
                                        }} 
                                        style={{width: 50, height: 50, padding: 10, cursor: 'pointer'}}
                                    />
                                }
                                {
                                    column.id === 'confirmation' &&
                                    <div>
                                        <span 
                                            style={{
                                                padding: 10,
                                                background: 'rgb(0, 231, 110)',
                                                color: 'rgb(36, 38, 62)',
                                                fontWeight: 700,
                                                borderRadius: 4,
                                                marginRight: 8,
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => {
                                                accept(row.id)
                                            }}
                                        >Подтвердить</span>
                                        <span 
                                            style={{
                                                padding: 10,
                                                background: '#8e1600',
                                                color: '#e8e8e8',
                                                fontWeight: 700,
                                                borderRadius: 4,
                                                marginRight: 8,
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => {
                                                cancel(row.id)
                                            }}
                                        >Отказать</span>
                                    </div>
                                }
                                {
                                    column.id !== 'confirmation' && column.id !== 'photo' && value
                                }
                            </TableCell>
                        );
                        })}
                    </TableRow>
                    );
                })}
                </TableBody>
                
                
            </Table>
            {
                    rows.length === 0 &&
                  
                    <div style={{width: '100%', height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        <span style={{color: '#7aa0c7', fontFamily: 'Roboto, sans-serif', fontWeight: 700, fontSize: 12}}>Данных нет</span>
                    </div>
                
                }
            </TableContainer>
            {
                pagination &&
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginTop: 8}}>
                    <select 
                        className={classes.select}
                        value={rowsPerPage}
                        onChange={(v) => {
                            setRowsPerPage(v.target.value);
                            changeRowsPerPage({
                                page: page,
                                rowsPerPage: v.target.value
                            });
                        }}
                    >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                    </select>
                    <input type="number" onChange={(v) => setPage(v.target.value)} value={page + 1} className={classes.inputnumber}/>
                    <span className={classes.countPage}>/ {allPage}</span>
                    <div style={{marginLeft: 12}}>
                        <span className={classes.arrowleft} onClick={() => {
                            if (page !== 0) {
                                changePage({page: page - 1, rowsPerPage: +rowsPerPage})
                                setPage(page - 1)
                            }
                            
                        }}>
                            <ArrowLeft style={{width: 10, height: 10, fill: '#0f3e67'}}/>
                        </span>
                        <span className={classes.arrowright} onClick={() => {
                            if (page !== +allPage - 1) {
                                changePage({page: page + 1, rowsPerPage: +rowsPerPage})
                                setPage(page + 1)
                            }
                        }}>
                            <ArrowRight style={{width: 10, height: 10, fill: '#0f3e67'}}/>
                        </span>
                    </div>
                </div>
            }
            <Dialog onClose={() => setOpenModal(false)} open={openModal}>
                <div>
                    <img src={photo} alt="logo" style={{display: 'block'}}/>
                </div>
            </Dialog>
        </div>
    )
}

export default TableCasinoKyc;